import React, { useState, useEffect } from "react";
import axios from "axios";
import Button from "@material-ui/core/Button";
import { useNotify, useUpdate } from "react-admin";
import DataProvider from "../DataProvider";
import ProgressBar from "./ProgressBar";

const UploadZoneMapButton = (props) => {
  const { record, setIsValid, resource } = props;
  const [progress, setProgress] = useState(0);
  const notify = useNotify();
  const [update, { loading }] = useUpdate();

  useEffect(() => {
    if (props) {
      handleFile();
    }
  }, [props]); // Dependency array to avoid calling handleFile on every render

  function handleClick() {
    const zoneMapInput = document.getElementById("zone-map-input");
    if (zoneMapInput) {
      zoneMapInput.click();
      setIsValid(false);
    }
  }

  async function handleFile() {
    const zoneMapInput = document.getElementById("zone-map-input");
    const file = zoneMapInput?.files[0];
    if (!file) return;
    zoneMapInput.value = null; // Clear the input after handling file

    const key = `${record.id}/map.${file.name.split(".").pop()}`;
    try {
      const { data: s3Data } = await axios.post(
        "/api/s3-bucket",
        { key },
        { headers: { "content-type": "application/json" } }
      );
      const formData = new FormData();
      Object.entries({
        ...s3Data.fields,
        "Content-Type": file.type,
        file,
      }).forEach(([name, value]) => {
        formData.append(name, value);
      });
      const response = await axios({
        method: "post",
        url: s3Data.url,
        data: formData,
        onUploadProgress: (p) => {
          setProgress(p.loaded / p.total);
        },
      });
      if (response.status === 204) {
        const map_url = `${s3Data.url}/zones/${key}`;
        update(resource, record.id, { map_url, id: record.id }, record, {
          onSuccess: () => {
            notify("Successfully uploaded zone map", "info");
          },
          onFailure: () => {
            notify("Error uploading zone map. Try again later", "warning");
          },
        });
        setIsValid(true);
        notify("Successfully uploaded zone map", "info");
      } else {
        setIsValid(false);
        notify("Error uploading zone map, try again later", "warning");
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("Failed to upload. Please try again.");
    }
  }

  return (
    <div>
      <Button variant="outlined" color="primary" onClick={handleClick}>
        <div style={{ color: "#03a9f4" }}>
          Upload Map
          <input
            id="zone-map-input"
            type="file"
            accept="image/png, image/gif, image/jpeg, application/pdf"
            style={{ display: "none" }}
            onChange={handleFile} // Trigger file handling on file change
          />
        </div>
      </Button>
      <ProgressBar progress={progress} />
    </div>
  );
};

export default UploadZoneMapButton;
